<template>
  <v-app>
    <Header v-if="this.$store.state.usuario.usuario == null"></Header>
    <HeaderLogged
      :key="$route.fullPath"
      v-if="this.$store.state.usuario.usuario != null"
    ></HeaderLogged>
    <v-main class="center">
      <transition name="slide">
        <router-view></router-view>
      </transition>
    </v-main>

    <Footer v-if="this.$store.state.usuario.usuario == null"></Footer>
  </v-app>
</template>
<style scoped>
.center {
  display: flex;
  align-items: center;
}
.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
  transition: 0.5s;
}

.slide-move {
  transition: transform 1s;
}
.slide-leave-active {
  animation: slide-out 1s ease-out forwards;
  transition: opacity 1s;
  opacity: 0;
  position: absolute;
}

@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(20px);
  }
}
</style>
<style>
body:has(.menuable__content__active .notification-card) {
  position: fixed;
  width: 100%;
  overflow: hidden;
}
.v-alert {
  margin: 1rem;
}
</style>
<script>
import Header from "./components/Headers/Header.vue";
import Footer from "./components/Headers/Footer.vue";
import HeaderLogged from "./components/Headers/HeaderLogged.vue";
import axios from "./axios-auth.js";

export default {
  name: "App",
  data() {
    return {
      notificationInterval: null,
    };
  },
  components: {
    Header,
    HeaderLogged,
    Footer,
  },
  methods: {
    async fetchNotifications() {
      try {
        const params = {
          idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          usuario: this.$store.state.usuario.usuario.toString().trim(),
        };
        const { data: listaRecordatorios } = await axios.get(
          "/Usuario/CargarRecordatorios?",
          {
            params,
          }
        );

        if (listaRecordatorios) {
          const listaRecordatoriosNotificacion = listaRecordatorios.filter(
            (item) => item.notifica
          );
          this.$store.dispatch(
            "setListaRecordatorios",
            listaRecordatoriosNotificacion
          );
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    },
  },

  mounted() {
    this.notificationInterval = setInterval(() => {
      if (
        this.$store.state.usuario.usuario !== null &&
        this.$store.state.usuario.institucion.idInstitucion !== null
      ) {
        this.fetchNotifications();
      }
    }, 5 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.notificationInterval);
  },
};
</script>
